import React from 'react';
import './Pricing.css';

// Import required components and constants
import { Button, Heading } from '../../../components';
import { pricing } from '../../../constants';

// Import icons
import { FaCheck } from 'react-icons/fa';

const Pricing = () => {
  return (  
    <section className='pricing' id='pricing'>

      {/* Heading for the Pricing section */}
      <Heading title={'Pricing Plans'} subTitle={'Explore our plans'} />

      <div className='box-container'> 
        { 
          // Map over the pricing array and render a price-item for each pricing plan
          pricing.map((item) => {
            const listItems = item.list;
            return( 
              <div className='plan-item' key={item.id}>

                <img src={item.image} alt={item.title} /> {/* Pricing plan image */}

                <div className='content'>

                  {/* Introductory section with title, icon, and price */}
                  <div className='intro'>
                    <div className='topIcon'>{item.icon}</div> {/* Icon representing the plan */}
                    <h3>{item.title}</h3> {/* Pricing plan Title */}
                    <div className='price'>${item.price}</div> {/* Pricing plan Price */}
                    <p>per month</p> {/* Pricing plan duration */}
                  </div>

                  {/* List of features included in the pricing plan */}
                  <ul>
                    {
                      // Map over the list of features for the pricing plan and render each feature
                      listItems.map((list, index) => {
                        return <li key={index}>
                          <div className='icon'><FaCheck /></div> {/* Checkmark icon for feature */}
                          {list} {/* Feature description */}
                        </li>
                      })
                    }
                  </ul>

                  {/* Display a "choose plan" button for each pricing plan */}
                  <Button link={'GetQuote'} title={'Get Started Now'} />

                </div>
              </div>
            )
          })
        }
      </div>

    </section>
  )
}

export default Pricing;